import {
  Flex,
  Spinner,
  Divider,
  VStack,
  GridItem,
  Grid,
} from "@chakra-ui/react";
import React from "react";
import { isBrowser } from "react-device-detect";
import { PageContainer } from "../../../components/atoms/Containers";
import { SectionContainer, SectionHeading } from "../AccountSettingsCommon";
import { BillingOwnerDetails } from "./BillingOwnerDetails";
import { SubscriptionDetails } from "./SubscriptionDetails";
import { useAccountSubscriptionData } from "./useAccountSubscriptionData";

export function AccountSubscriptionSettings() {
  const {
    subscription,
    account,
    plans,
    downgradePlan,
    redirecting,
    setRedirecting,
    isLoading,
    hasError,
  } = useAccountSubscriptionData();

  if (isLoading || !account || !plans || hasError) {
    return (
      <PageContainer isBrowser={isBrowser}>
        <Flex justifyContent="center" my="40px">
          <Spinner />
        </Flex>
      </PageContainer>
    );
  }

  return (
    <SectionContainer>
      <SectionHeading>Subscription</SectionHeading>
      <VStack w="full" align="start" fontSize="sm">
        <Grid w="full" templateColumns="auto auto" gap={8}>
          <SubscriptionDetails
            subscription={subscription}
            downgradePlan={downgradePlan}
            isRedirecting={redirecting}
            setIsRedirecting={setRedirecting}
          />
          <GridItem colSpan={2}>
            <Divider />
          </GridItem>
          <BillingOwnerDetails />
        </Grid>
      </VStack>
    </SectionContainer>
  );
}
